import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TonalityService, Tonality } from "../../../services/tonality.service";
import { BaseComponent } from "../../base.component";
import { PaginationService } from "app/services/pagination.service";
import { NotificationsService } from "angular2-notifications";

@Component({
	selector: 'app-tonalities',
	templateUrl: './tonalities.component.html',
	styleUrls: ['./tonalities.component.less']
})
export class TonalitiesComponent extends BaseComponent implements OnInit {

	tonalities:any[];
	tonality:Tonality;
	cur_tonality:Tonality;

	formTitle:string;
	buttonTitle:string;

	pager: any = {};
	pagedItems: any[];

	tonForm: NgForm;
	@ViewChild('tonForm') currentForm: NgForm;

	constructor(
		private tonalityService: TonalityService,
		private paginationService: PaginationService,
		private notificationsService: NotificationsService,
	) {
		super();
	}

	ngOnInit() {
		this.tonalityService.getTonalities().subscribe((tonalities) => {
			this.tonalities = tonalities.sort((a,b)=> {
				if(a.name == b.name)
				{
					return 0;
				}
				return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
			})
			this.setPage(1);
		});
		this.tonality = new Tonality();
	}

	setPage(page: number) {
        // get pager object from service
        this.pager = this.paginationService.getPager(this.tonalities.length, page);

        // get current page of items
        this.pagedItems = this.tonalities.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

	clickEdit(tonality)
	{
		this.formTitle = 'Edit Tonality';
		this.buttonTitle = 'Update Tonality';
		this.cur_tonality = tonality;
		this.tonality = Object.assign(new Tonality(), tonality);
	}

	clickAdd()
	{	
		this.formErrors.name = '';
		this.formTitle = 'Add New Tonality';
		this.buttonTitle = 'Save Tonality';
		this.tonality = new Tonality();
		this.cur_tonality = null;
	}

	onDeleteClick(key) {
		var self = this;
		if (confirm('Are you sure?')) {
			this.tonalityService.deleteTonality(key).then(function(){
				self.notificationsService.error('Deleted', '1 tonality deleted');
			});
		}
	}

	formAction()
	{
		var form_element = <HTMLFormElement>document.getElementById("form");
		var self = this;
		if(this.tonality)
		{
			if(this.formValidation(false))
			{
				if(!this.cur_tonality)
				{
					this.tonalityService.addTonality(this.tonality).then(function(){
						self.notificationsService.success('Added', '1 tonality added')
						form_element.reset();
					}).catch(function(e){
						console.log(e.message)
					});
				}
				else
				{
					this.tonalityService.updateTonality(this.cur_tonality.$key, this.tonality).then(function(){
						self.notificationsService.success('Updated', '1 tonality updated')
						form_element.reset();
					}).catch(function(e){
						console.log(e.message)
					});
				}
			}
		}
	}

	ngAfterViewChecked() {
		this.formChanged();
	}

	formChanged() {
		if (this.currentForm === this.tonForm) { return; }

		this.tonForm = this.currentForm;
		if (this.tonForm) {
			this.tonForm.valueChanges
				.subscribe(data => {
					this.formValidation(true)
				});
		}
	}

	formValidation(checkDirty = true) {
		const form = this.tonForm.form;
		for (const field in form.controls) {
			const control = form.get(field)
			if (control) {
				if (checkDirty && !control.dirty) {
					continue;
				}
				this.formErrors[field] = '';
				if (!control.valid) {
					const messages = this.validationMessages[field] || {};
					for (const key in control.errors) {
						this.formErrors[field] += messages[key] + ' ';
					}
				}
			}
		}
		return form.valid;
	}

	formErrors = {
		'name' : ''
	};

	validationMessages = {
		'name': {
			'required': 'This field is required.',
		}
	};
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/tonality/tonalities/tonalities.component.ts